// Libraries
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import SearchIcon from '@mui/icons-material/Search';

// Core
import { ResourceTextApplication } from '../../core/resources';

// Common
import { AActionButton, ADefaultButton, AButtonBaseProps } from '../../common/buttons';

export interface ASearchButtonProps extends Omit<AButtonBaseProps, 'children'> {
    children?: ReactNode;
    type?: 'action' | 'default';
}

export default function ASearchButton(props: ASearchButtonProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaGeneral']);
    const { children, type, ...actionButtonProps } = props;
    const children2 = children ? children : t('AnelmaGeneral:1055');

    if (type === 'action')
        return <AActionButton {...actionButtonProps} children={children2} icon={<SearchIcon />} />;
    return <ADefaultButton {...actionButtonProps} children={children2} icon={<SearchIcon />} />;
}
